import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { NgbPopover, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-powertrain-performance",
  templateUrl: "./powertrain-performance.component.html",
  styleUrls: ["./powertrain-performance.component.scss"],
  standalone: true,
  imports: [CommonModule, PowertrainModalComponent, MatButtonModule,MatTooltip, MatTooltipModule,NgbPopover,NgbPopoverModule],
  encapsulation: ViewEncapsulation.None,
})
export class PowertrainPerformanceComponent implements OnInit {
  powertrainPerformanceUrl =
    BaseUrlConstantsService.POWERTRAIN_PERFORMANCE_METRICS_API;
  performance_metrics: any = {};
  performance_metrics_err: boolean = false;
  performance_metrics_loader: boolean = true;

  @Input("subsystem_id") subsystemId!: string | number;
  @Input("client_id") client_id!: string | number;
  @Input("commission_date") commission_date: string;
  gid = "b6250daa-3dfb-4ca0-b334-2dde33cd23c7";

  showModal: boolean = false;
  openCommissionModal: boolean = false;

  public isOutForService = false;
  public showOFSModal = false;
  public outOfServiceChange = false;

  constructor(
    private service: PowerTrainService,
    private spinner: BackendApiService
  ) {}

  ngOnInit(): void {
    // this.fetchPerformanceMetrics();
    this.fetchPerformanceMetricsV2();
  }

  fetchPerformanceMetrics() {
    this.service
      .fetchPerformanceMetrics(this.powertrainPerformanceUrl + this.subsystemId)
      .then((performanceMetricsRes: any) => {
        this.performance_metrics = {
          asset_availability: performanceMetricsRes.asset_availability,
          asset_performance: performanceMetricsRes.asset_performance,
          OEE: Math.floor(performanceMetricsRes.OEE),
          subsystem_id: this.subsystemId,
          gid: this.gid,
          client_id: this.client_id,
        };
      })
      .catch((error) => {
        this.performance_metrics_err = true;
        // this.spinner.showError("Failed to fetch performance metrics");
        this.performance_metrics = {
          asset_availability: "N/A",
          asset_performance: "N/A",
          OEE: "N/A",
          subsystem_id: this.subsystemId,
          gid: this.gid,
          client_id: this.client_id,
        };
      })
      .finally(() => {
        this.performance_metrics_loader = false;
      });
  }
  fetchPerformanceMetricsV2() {
    this.service
      // .fetchPerformanceMetrics(
      //   "http://localhost:7777/powertrain/failures/" + this.subsystemId
      // )
      .fetchPerformanceMetrics(this.powertrainPerformanceUrl + this.subsystemId)
      .then((performanceMetricsRes: any) => {
        console.log(performanceMetricsRes);
        this.performance_metrics = {
          availability_time: performanceMetricsRes.availability_time+' hrs',
          last_commission_date: performanceMetricsRes.last_commission_date,
          out_for_service: performanceMetricsRes.out_for_service,
          subsystem_id: this.subsystemId,
          last_record_id: performanceMetricsRes.last_record_id,
        };
        this.isOutForService = performanceMetricsRes.out_for_service;
        this.commission_date=performanceMetricsRes.last_commission_date
      })
      .catch((error) => {
        this.performance_metrics_err = true;
        this.spinner.showError("Failed to fetch performance metrics");
        this.performance_metrics = {
          asset_availability: "N/A",
          asset_performance: "N/A",
          OEE: "N/A",
          subsystem_id: this.subsystemId,
          gid: this.gid,
          client_id: this.client_id,
        };
      })
      .finally(() => {
        this.performance_metrics_loader = false;
      });
  }

  updatePerformanceMetrics() {
    this.showModal = true;
    document.body.style.overflow = "hidden"; // Disable background scroll
  }
  closeBox(data: any) {
    document.body.style.overflow = "auto"; // Enable background scroll
    console.log("Received data:", data); // This will now correctly log the emitted data.
    this.showModal = false;

    if (data?.updatedData) {
      this.performance_metrics.asset_availability =
        data.updatedData.availability;
      this.performance_metrics.asset_performance = data.updatedData.performance;
      this.performance_metrics.OEE = Math.floor(data.updatedData.OEE);
    }
  }
  openCommissionDate() {
    this.openCommissionModal = true;
  }
  closeCommissionDate(data: any) {
    this.openCommissionModal = false;
    if (data.reload) {
      this.fetchPerformanceMetricsV2();
    }
  }

  toggleOn(event) {
    event.target.checked = this.isOutForService;
    this.outOfServiceChange = !this.isOutForService;
    this.showOFSModal = true;
  }

  closeOFSModal(data: any) {
    this.showOFSModal = false;
  }

  closeOutForServiceModal(data: any) {
    console.log(data);
    this.showOFSModal = false;
    if (data.reload) {
      this.fetchPerformanceMetricsV2();
    }
  }
}
